import React from 'react'

const Footer = () => {
  return (
    <div className='container-fluid footer'>
      <strong>HorlatechStore</strong>
      <span>Copyright © 2023 . All rights reserved.</span>
  </div>
  )
}

export default Footer